module.exports = __webpack_public_path__ + "static/agritech_logo_mini-429d88a86118b15bfe8832987542a104.png";